import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Api from "../services/api";

const appSlice = createSlice({
    name: "app",
    initialState: {
        data: null,
        apps: [],
        allApps: [],
    },
    reducers: {
        setApp: (state, action) => {
            state.data = action.payload;
        },
        addApp: (state, action) => {
            state.apps.unshift(action.payload);
        },
        setApps: (state, action) => {
            state.apps = action.payload;
        },
        setAllApps: (state, action) => {
            state.allApps = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchApps.fulfilled, (state, action) => {
                state.apps = action.payload;
            })
            .addCase(fetchAllApps.fulfilled, (state, action) => {
                state.allApps = action.payload;
            });
    }
});

// Export actions
export const { setApp, addApp, setApps, setAllApps } = appSlice.actions;

export const fetchApps = createAsyncThunk(
    'app/fetchApps',
    async (params = {}) => {
        const response = await Api.get('/api/app_list', { params });
        return response.data.data;
    }
);

export const fetchAllApps = createAsyncThunk(
    'app/fetchAllApps',
    async () => {
        const response = await Api.get('/api/app_list', { params: {} });
        return response.data.data;
    }
);
export default appSlice.reducer;
